import { Loader2 } from "lucide-react";

interface StreamingSectionProps {
  sectionName: string;
}

export function StreamingSection({ sectionName }: StreamingSectionProps) {
  return (
    <div className="rounded-xl border border-sky-100 bg-info-soft/40 p-5">
      <div className="flex items-center gap-3">
        <Loader2 className="h-4 w-4 text-primary animate-spin shrink-0" />
        <span className="text-xs font-bold tracking-wider uppercase text-primary">
          {sectionName} &middot; GENERATING
        </span>
      </div>
    </div>
  );
}
